import React from 'react';
import { ReactEditor } from 'slate-react';
import styles from '../../../../components/Toolbar/Toolbar.module.css';
import classnames from 'classnames';
import { type FontFamily, defaultFontList } from '../fontList';
import { type ToolbarSubmenuProps } from '../../../../types/aha-editor';
import type ToolMark from '../../tools/ToolMark';
import MarkUtils from '../../../../AhaEditorUtils/MarkUtils';

const DEFAULT_FONT_FAMILY = 'sans-serif';

const FontFamilyPicker: React.FC<ToolbarSubmenuProps<typeof ToolMark>> = ({
  editor,
  controller,
  tool,
  isSubmenu,
}) => {
  const currentFontFamily =
    MarkUtils.getMarkAtSelection(editor, tool.mark) ?? DEFAULT_FONT_FAMILY;

  const handleFontFamilyChange = (fontFamily: FontFamily) => {
    tool.addMark(editor, controller, fontFamily.fontFamily);
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu submenu={isSubmenu}>
      <div
        slot="control"
        className={classnames({
          [styles.toolbarButtonDisabled]: !tool.isEnabled({
            editor,
            controller,
          }),
        })}
      >
        <i className={classnames('fa-fw', tool.iconClass)} />
        {isSubmenu && tool.label}
      </div>
      <aha-menu-content>
        {defaultFontList.map((fontFamily) => (
          <aha-menu-item
            key={`font-family-${fontFamily.displayName ?? ''}`}
            selected={fontFamily.styleName === currentFontFamily ? true : null}
            onClick={() => handleFontFamilyChange(fontFamily)}
          >
            <div
              style={{
                fontFamily: fontFamily.fontFamily,
                padding: '6px 8px',
              }}
            >
              {fontFamily.displayName}
            </div>
          </aha-menu-item>
        ))}
      </aha-menu-content>
    </aha-menu>
  );
};

export default FontFamilyPicker;
